import { uniq } from 'lodash';

export const functionalGroup = (
  { functionalGroups },
  { functionalGroupId },
) => {
  return functionalGroups.byId[functionalGroupId];
};

export const visibleTemplateIds = (
  { modelsWorkingState, functionalGroups, templatesWorkingState, templates },
  { functionalGroupId },
) => {
  const modelWorkingState =
    modelsWorkingState.byId[functionalGroups.byId[functionalGroupId].modelId];
  if (modelWorkingState && templates.byId) {
    const inProgressTemplateIds = modelWorkingState.templatesWorkingState;
    const functionalGroupInProgressTemplateIds = inProgressTemplateIds.filter(
      templateId =>
        templates.byId[templateId] && templates.byId[templateId].functionalGroupId === functionalGroupId,
    );
    return uniq(functionalGroupInProgressTemplateIds);
  } else {
    return [];
  }
};

export const submittedTemplateIds = (
  { modelsWorkingState, functionalGroups, templatesSubmitted, templates },
  { functionalGroupId },
) => {
  const modelWorkingState =
    modelsWorkingState.byId[functionalGroups.byId[functionalGroupId].modelId];
  if (modelWorkingState) {
    const submittedTemplateIds = modelWorkingState.templatesSubmitted || [];
    const functionalGroupSubmittedTemplateIds = submittedTemplateIds.filter(
      templateId =>
        templates.byId[templateId] && templates.byId[templateId].functionalGroupId === functionalGroupId,
    );
    return uniq(functionalGroupSubmittedTemplateIds);
  } else {
    return [];
  }
};

export const submittedQuantityByFunctionalGroup = (
  { modelsWorkingState, functionalGroups, templatesSubmitted, templates },
  { functionalGroupId },
) => {
  let submittedTemplate, prioritiesToQuantities;
  const modelWorkingState =
    modelsWorkingState.byId[functionalGroups.byId[functionalGroupId].modelId];

  if (modelWorkingState) {
    const submittedTemplateIds = modelWorkingState.templatesSubmitted || [];
    const submittedQuantityByFunctionalGroup = submittedTemplateIds
      .filter(
        templateId =>
          templates.byId[templateId] && templates.byId[templateId].functionalGroupId === functionalGroupId,
      )
      .reduce((quantitiesArray, templateId) => {
        submittedTemplate = templatesSubmitted.byId[templateId];
        prioritiesToQuantities = submittedTemplate.prioritiesToQuantitiesMap;
        return quantitiesArray.concat(Object.values(prioritiesToQuantities));
      }, [])
      .reduce((total, quantity) => total + quantity, 0);

    return submittedQuantityByFunctionalGroup;
  } else {
    return 0;
  }
};
